<div class="row w-100"
  style="position:absolute; top:0; z-index:1050"
  (click)="closePopup()">
<div class="col w-100 pr-4">
<div class="card w-100 mt-3 border border-primary">
<div class="card-header">
<p class="card-title">{{ page.title }}</p>
</div>
<div class="card-body" [innerHtml]="page.content">
</div>
<div class="card-footer">
<button
  type="button"
  (click)="closePopup()"
  class="btn btn-secondary float-end"
  i18n="Close">BUTTON_CLOSE</button>
</div>
</div>
</div>
</div>
